<template>
  <header class="header">
    <div class="header-bar">
      <router-link :to="{ path: '/' }">
        <div class="logo">
          Nude på
          <br />
          nätet
        </div>
      </router-link>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-bar {
  align-items: flex-start;
  background-image: url('~@/assets/svg/header-bg.svg');
  background-position: 0% 0%;
  background-repeat: no-repeat;
  display: flex;
  height: 70px;
  justify-content: space-between;
  position: relative;
  z-index: 10;
}

.logo {
  //background-color: $green;
  color: $white;
  font-family: Fugaz One;
  font-size: 18px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: -0.04em;
  line-height: 104%;
  padding: 15px;
  text-transform: uppercase;
}

.contact-menu-button {
  padding: 10px;

  .inner-button {
    align-items: center;
    background-color: $green;
    background-color: #256a52;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 44px;
    justify-content: center;
    padding: 10px;

    width: 44px;
  }
}

.contact-menu {
  background-image: url('~@/assets/svg/contact-menu-bg.svg');
  background-position: 50% 100%;
  background-repeat: no-repeat;
  background-size: 768px 679px;
  color: $white;

  position: absolute;
  top: 0;
  width: 100%;

  .inner {
    margin: auto;
    max-width: $content-max-width;
    padding: 100px 25px 70px;
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s;
}

.slide-down-enter,
.slide-down-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
}

@media screen AND (min-width: $medium-screen) {
  .logo {
    font-size: 34px;
    padding: 20px;
  }

  .header-bar {
    background-size: auto 220%;
    height: 110px;
  }

  .contact-menu-button {
    margin: 5px;

    .inner-button {
      height: 54px;
      width: 54px;

      img {
        width: 90%;
      }
    }
  }
}
</style>
